<button mat-icon-button (click)="openMenu()" *ngIf="(brandingKey === CustomClients.Vorwerk && collectionOwner) || brandingKey !== CustomClients.Vorwerk">
  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
  <div
    class="overlayMenu"
    matTooltip="Asset actions"
    #taskMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="assetActionMenu"
    (menuOpened)="menuOpened(collection._id)"
    (menuClosed)="menuClosed(collection._id)"
  ></div>
</button>
<mat-menu #assetActionMenu="matMenu" [overlapTrigger]="true">
  <ng-template matMenuContent>
    <sp-loading-inprogress [showSpinner]="true" [diameter]="spinnerDiameter" class="mt-3 inline-block" *ngIf="httpCallInProgress; else loadingWorkflow"></sp-loading-inprogress>
    <ng-template #loadingWorkflow>
      <button *ngIf="collectionOwner" mat-menu-item (click)="editCollection.emit()">
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span i18n>Edit collection</span>
      </button>
      <button *ngIf="brandingKey !== CustomClients.Vorwerk" mat-menu-item (click)="downloadCollection.emit()">
        <mat-icon class="material-icons-outlined">file_download</mat-icon>
        <span i18n>Download collection</span>
      </button>
      <button *ngIf="collectionOwner && !collectionPublished" mat-menu-item (click)="publishCollection.emit()">
        <mat-icon class="material-icons-outlined">feed</mat-icon>
        <span i18n>Publish collection</span>
      </button>
      <button *ngIf="collectionOwner && collectionPublished" mat-menu-item (click)="unpublishCollection.emit()">
        <mat-icon class="material-icons-outlined">feed</mat-icon>
        <span i18n>Unpublish collection</span>
      </button>
      <button *ngIf="brandingKey !== CustomClients.Vorwerk && !assetDetails && (AnyAsset | can: 'share')" mat-menu-item (click)="shareCollection.emit()">
        <mat-icon class="material-icons-outlined">share</mat-icon>
        <span i18n>Share collection</span>
      </button>
      <button *ngIf="collectionOwner" mat-menu-item (click)="deleteCollection.emit()">
        <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
        <span i18n>Delete collection</span>
      </button>
    </ng-template>
  </ng-template>
</mat-menu>
